import React from "react";
import { useDispatch } from "react-redux";
import actions from "@Src/redux/rootActions";
import { useGetStoreConfig, useGetAttractions } from "./GetStoreMappings.hooks";

const { setAttractionsList, setStoreMappings } = actions.attractions;

const GetStoreMappings = () => {
  const dispatch = useDispatch();
  const storeConfig = useGetStoreConfig();
  const attractionsList = useGetAttractions();

  /**
   * Filter the store mappings config to only include stores that have a matching attraction_id in the attractions list
   */
  const filterMappings = React.useCallback(() => {
    const config = [...storeConfig];
    let mappings = {
      storeMappings: [],
      offerMappings: [],
    };
    for (let i = 0; i < config.length; i++) {
      let store = config[i];
      if (store.hasOwnProperty("attraction_id")) {
        let attraction = attractionsList.find(
          (attr) => attr.attractionIdentifier === store.attraction_id,
        );
        // if there is a matching attraction, add the store to the correct mapping array
        if (attraction) {
          // Add the attraction type to the store object
          store.type = attraction.attractionType;
          if (store.hasOwnProperty("offer_group_keys")) {
            // Add a retailer_id from the attraction_id to the store object for travel app mapping
            store.retailer_id = store.attraction_id;
            mappings.offerMappings.push(store);
          } else if (store.hasOwnProperty("store_keys")) {
            if (store.type !== "ATTRACTION") {
              // Add a retailer_id from the attraction_id to the store object for travel app mapping
              store.retailer_id = store.attraction_id;
            }
            mappings.storeMappings.push(store);
          }
        }
      }
    }
    dispatch(setStoreMappings(mappings));
    dispatch(setAttractionsList(attractionsList));
  }, [storeConfig, attractionsList, dispatch]);

  React.useEffect(() => {
    if (storeConfig && attractionsList) {
      filterMappings();
    }
  }, [storeConfig, attractionsList, filterMappings]);

  return <></>;
};

export default GetStoreMappings;
